import api from "services/api";

export async function fetchQualifications(
  pageSize = 10,
  pageNumber = 1,
  searchTerm = "",
  sortColumn = "qualificationId",
  sortDirection = "ASC"
) {
  try {
    const params = {
      pageSize,
      pageNumber,
      searchTerm,
      sortColumn,
      sortDirection,
    };
    const response = await api.get(`/Qualification`, { params });
    if (response.data && Array.isArray(response.data.data)) {
      return {
        items: response.data.data,
        totalItems: response.data.totalCount || 0,
      };
    }
    return { items: [], totalItems: 0 };
  } catch (err) {
    console.error("Error fetching qualifications:", err);
    throw err;
  }
}

export async function getQualificationsByPersonnelId(
  personnelId,
  pageSize = 100,
  pageNumber = 1
) {
  try {
    const params = { pageSize, pageNumber };
    const response = await api.get(`/Qualification/personnel/${personnelId}`, {
      params,
    });
    return response.data;
  } catch (err) {
    console.error(
      `Error fetching qualifications for personnel ${personnelId}:`,
      err
    );
    throw err;
  }
}

export async function createQualification(data) {
  try {
    const response = await api.post("/Qualification", data);
    return response.data;
  } catch (err) {
    console.error("Error creating qualification:", err);
    throw err;
  }
}

export async function updateQualification(id, data) {
  try {
    const response = await api.put(`/Qualification/${id}`, data);
    return response.data;
  } catch (err) {
    console.error(`Error updating qualification ${id}:`, err);
    throw err;
  }
}

export async function deleteQualification(id) {
  try {
    const response = await api.delete(`/Qualification/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Error deleting qualification ${id}:`, err);
    throw err;
  }
}

export async function deleteQualificationsByPersonnelId(personnelId) {
  try {
    const response = await api.delete(
      `/Qualification/personnel/${personnelId}`
    );
    return response.data;
  } catch (err) {
    console.error(
      `Error deleting qualifications for personnel ${personnelId}:`,
      err
    );
    throw err;
  }
}

// Create a service object for named export
const qualificationService = {
  fetchQualifications,
  getQualificationsByPersonnelId,
  createQualification,
  updateQualification,
  deleteQualification,
  deleteQualificationsByPersonnelId,
};

export default qualificationService;
